import React, { FC } from "react";
import { CustomDropdown } from "./CustomDropdown";
import { twMerge } from "tailwind-merge";

export const DropdownArea: FC<{
  options: OptionProps[];
  defaultSelected?: OptionPropsValue[];
  onSelect: (options: OptionProps[]) => void;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}> = ({
  options,
  children,
  defaultSelected,
  onSelect,
  title,
  className,
  disabled,
}) => {
  if (!options || options.length === 0) {
    return null;
  }
  return (
    <div className={className ? className : "mb-4"}>
      {title && (
        <p className="mb-2 text-sm font-normal text-[#5E6D77]">{title}</p>
      )}
      {children}
      <div
        className={twMerge(
          "wei-1 relative flex w-full items-center justify-between rounded-[1rem] border border-[#DCDCDC] bg-white px-4 py-[0.875rem] sm:w-[240px] sm:px-5 sm:py-[0.75rem]",
          className,
          disabled ? "opacity-50" : "",
        )}
      >
        <CustomDropdown
          className="w-full"
          disabled={disabled}
          options={options.map((option) => ({
            value: option.value,
            label: option.displayName,
          }))}
          value={defaultSelected?.[0]}
          onChange={(selectedValues: any) => {
            const selectedOptions = options.filter((option) =>
              Array.isArray(selectedValues)
                ? selectedValues.includes(option.value)
                : selectedValues === option.value,
            );
            onSelect(selectedOptions);
          }}
        />
      </div>
    </div>
  );
};
